/* 🤖 this file was generated by svg-to-ts */
export const iccIconDelete: {
  name: 'delete';
  data: string;
} = {
  name: 'delete',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 9v10H8V9h8Zm-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1ZM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7Z" fill="currentColor"/></svg>`
};
